import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
  ViewChild
} from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { environment } from '@env/environment';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { finalize } from 'rxjs';
import { FormService } from 'src/app/core/util/form.service';
import { ReportingService } from 'src/app/core/util/reporting.service';

@Component({
  selector: 'app-report-clone',
  templateUrl: './report-clone.component.html',
  styles: [],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzModalModule,
    NzInputModule,
    NzFormModule,
    NzToolTipModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportCloneComponent {
  @Output() readonly closed = new EventEmitter();
  visible = false;
  loading = false;
  report: any = {};
  openAfterClone = true;
  @ViewChild('f') f!: NgForm;
  constructor(
    private fs: FormService,
    private cdr: ChangeDetectorRef,
    private http: _HttpClient,
    private reporting: ReportingService
  ) {}
  submit() {
    if (!this.fs.validate(this.f).isValid) return;

    this.loading = true;
    this.http
      .post(
        `${this.reporting.reportServerUrl}/api/ReportFiles/Clone`,
        this.report
      )
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe(res => {
        this.visible = false;
        this.report.reportUrl = res.reportUrl;
        this.report.displayName = res.displayName;
        if (this.openAfterClone) {
          this.http
            .post(
              `${this.reporting.reportServerUrl}/api/reportTasks/Create?_silent=true`,
              { reportUrl: res.reportUrl }
            )
            .subscribe(res2 => {
              // var url = `${window.location.origin}/#/reporting/viewer/design/${res2.reportType}/rt-${res2.taskId}`;
              // window.open(url, '_blank');
              this.reporting.openDesigner(res2.reportType, `rt-${res2.taskId}`);
            });
        } else this.closed.emit(true);
      });
  }

  show(report: any, openAfterClone: boolean = true) {
    this.report.taskId = report.taskId;
    this.report.reportUrl = report.reportUrl;
    this.report.displayName = `Copy of ${report.displayName}`;
    this.visible = true;
    this.openAfterClone = openAfterClone;
    this.cdr.detectChanges();
  }
}
